import _ from 'lodash';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import Button from './Button';
import ReactTablePagination from './ReactTablePagination';
import { isEmptyString } from '../../validators/formValidators';
import { colorMap } from '../../helpers/colors';
import { findBootstrapEnvironment } from '../../helpers/utils';


class ItemsForm extends PureComponent {
    constructor(props) {
        super(props);
        this.add = this.add.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onClone = this.onClone.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.moveSelectedTypeUp = this.moveSelectedTypeUp.bind(this);
        this.moveSelectedTypeDown = this.moveSelectedTypeDown.bind(this);
        this.renderEditable = this.renderEditable.bind(this);
        this.removeButton = this.removeButton.bind(this);
        this.cloneButton = this.cloneButton.bind(this);
        this.tableRef = React.createRef();
        this.state = {
            items: [],
            selectedIndex: -1,
            page: 0,
        };
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        let items = _.cloneDeep(nextProps.items);
        if (items) {
            this.setState({items});
            if (nextProps.defaultSelectedIndex >= 0 && nextProps.defaultSelectedIndex < items.length) {
                let page = 0;
                if (this.tableRef.current) {
                    page = parseInt((nextProps.defaultSelectedIndex - 1) / this.tableRef.current.state.pageSize, 10);
                }

                this.setState({
                    selectedIndex: nextProps.defaultSelectedIndex,
                    page,
                });

            } else {
                this.setState({
                    selectedIndex: -1,
                    page: 0,
                });
            }
        }
    }

    onDelete(index) {
        if (index < 0) {
            return;
        }

        const items = _.cloneDeep(this.state.items);
        items.splice(index, 1);
        const page = parseInt((index - 1) / this.tableRef.current.state.pageSize, 10);
        this.setState({
            items,
            selectedIndex: this.state.selectedIndex === index ? index - 1 : this.state.selectedIndex,
            page,
        });
        this.props.setItems(items);
    }

    onAdd() {
        this.add(this.props.defaultItem, '');
    }

    onClone(index) {
        if (index < 0) {
            return;
        }

        this.add(this.state.items[index]);
    }

    add(defaultItem = this.props.defaultItem, newLabelBase = '') {
        for (let i = 1; ; i += 1) {
            const items = _.cloneDeep(this.state.items);
            items.push(defaultItem);
            const page = parseInt((items.length - 1) / this.tableRef.current.state.pageSize, 10);
            this.setState({
                items,
                selectedIndex: items.length - 1,
                page,
            }, () => {
                // The new row is at the end of the list: scroll to it.
                const body = ReactDOM.findDOMNode(this.tableRef.current).querySelector('.rt-tbody');
                if (body) {
                    body.scrollTop = body.scrollHeight;
                }
            });

            this.props.setItems(items);
            break;
        }
    }

    moveSelectedTypeUp(evt) {
        const items = this.state.items;
        let selectedIndex = this.state.selectedIndex;
        if (selectedIndex < 0) {
            return;
        }

        const tmpHeader = items[selectedIndex - 1];
        items[selectedIndex - 1] = items[selectedIndex];
        items[selectedIndex] = tmpHeader;
        selectedIndex -= 1;
        this.setState({
            items,
            selectedIndex,
            page: parseInt(selectedIndex / this.tableRef.current.state.pageSize, 10),
        });
        this.props.setItems(items);
    }

    moveSelectedTypeDown(evt) {
        const items = this.state.items;
        let selectedIndex = this.state.selectedIndex;
        if (selectedIndex < 0) {
            return;
        }

        const tmpHeader = items[selectedIndex + 1];
        items[selectedIndex + 1] = items[selectedIndex];
        items[selectedIndex] = tmpHeader;
        selectedIndex += 1;
        this.setState({
            items,
            selectedIndex,
            page: parseInt(selectedIndex / this.tableRef.current.state.pageSize, 10),
        });
        this.props.setItems(items);
    }

    renderEditable(cellInfo) {
        let selectedIndex = cellInfo.index;
        let modificationDisabled = this.props.modificationDisabled(this.state.items, selectedIndex);
        if (this.props.enableEdit !== undefined) {
            modificationDisabled = modificationDisabled || !this.props.enableEdit;
        }

        const content = this.props.renderItem(selectedIndex, this.state.items, modificationDisabled);
        return content;
    }

    removeButton(cellInfo) {
        let modificationDisabled = this.props.modificationDisabled(this.state.items, cellInfo.index);
        if (this.props.enableDelete !== undefined) {
            modificationDisabled = modificationDisabled || !this.props.enableDelete;
        }

        return (
            <Button onClick={() => this.onDelete(cellInfo.index)}
                    disabled={modificationDisabled}
                    icon="trash"
                    style={{margin: -5}}
                    bsStyle="link"
                    tooltip="Delete selcted record"
            />);
    }

    cloneButton(cellInfo) {
        let disabled = false;
        if (this.props.enableAdd !== undefined) {
            disabled = !this.props.enableAdd;
        }

        return (
            <Button onClick={() => this.onClone(cellInfo.index)}
                    icon="duplicate"
                    style={{margin: -5}}
                    bsStyle="link"
                    disabled={disabled}
                    tooltip="Duplicate (clone) selected record"
            />
        );
    }

    render() {
        let saveDisabled = (!!this.state.items && this.state.items.find(v => (v && !isEmptyString(v['$Error$'])))) ||
                           this.state.selectedIndex < 0;

        const size = findBootstrapEnvironment();

        return (
            <Row>
                <Col xs={9} md={10}>
                    <ReactTable PaginationComponent={ReactTablePagination}
                                ref={this.tableRef}
                                data={this.state.items}
                                page={0}
                                showPagination={false}
                                pageSize={Math.max((this.state.items || []).length, 1)}
                                columns={[
                                    {
                                        accessor: 'item',
                                        Cell: this.renderEditable,
                                    },
                                    {
                                        width: 50,
                                        Cell: this.cloneButton,
                                    },
                                    {
                                        width: 50,
                                        Cell: this.removeButton,
                                    }
                                ]}
                                className="-highlight ct-scroll"
                                minRows={0}
                                sortable={false}
                                resizable
                                filterable={false}
                                loading={this.state.items === undefined}
                                getTableProps={() => {
                                    return {
                                        style: {
                                            borderLeft: "0 none",
                                            borderRight: "0 none",
                                        }
                                    }
                                }}
                                getTrProps={(state, rowInfo, column) => {
                                    let index = rowInfo.index;
                                    let errorColor = `rgba(${colorMap['red']}, 0.15)`;
                                    let background = '';
                                    if (this.state.items[rowInfo.index]['$Error$']) {
                                        background = errorColor;
                                    } else if (index === this.state.selectedIndex) {
                                        background = 'rgba(63,144,63,0.15)';
                                    }

                                    return {
                                        style: {
                                            paddingTop: 5,
                                            height: rowInfo.original['$Error$'] ? 60 : 50,
                                            background,
                                        },
                                    };
                                }}
                    />
                </Col>
                <Col md={2} xs={3}>
                    <FormGroup controlId="workflowUpDown">
                        <ControlLabel>Reorder</ControlLabel>
                        <Row>
                            <Button onClick={this.moveSelectedTypeUp}
                                    disabled={this.state.selectedIndex <= 0}
                                    block
                                    icon="menu-up"
                                    tooltip="Move selected record up"
                            />
                        </Row>
                        <Row>
                            <Button onClick={this.moveSelectedTypeDown}
                                    disabled={this.state.selectedIndex < 0 ||
                                                this.state.selectedIndex === this.state.items.length - 1}
                                    block
                                    icon="menu-down"
                                    tooltip="Move selected record down"
                            />
                        </Row>
                        <Row>
                            <Button onClick={this.onAdd}
                                    disabled={this.props.enableAdd !== undefined && !this.props.enableAdd}
                                    style={{marginBottom: 15}}
                                    block
                                    icon="plus"
                                    iconStyle={{
                                        paddingBottom: '6px'
                                    }}
                                    label="Add"
                                    tooltip="Add new record"
                            />
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}

ItemsForm.propTypes = {
    items: PropTypes.array.isRequired,
    defaultItem: PropTypes.object.isRequired,
    renderItem: PropTypes.func.isRequired,
    setItems: PropTypes.func.isRequired,
    defaultSelectedIndex: PropTypes.int,
    modificationDisabled: PropTypes.func.isRequired,
    dispatchSaveAction: PropTypes.func,
    saveAction: PropTypes.func,
    enableAdd: PropTypes.bool,
    enableEdit: PropTypes.bool,
    enableDelete: PropTypes.bool,
}

export default connect()(ItemsForm);
